import React from 'react';
import useStore from '../store/useStore';

const ApiLoadingOverlay = () => {
  const { apiLoading, loadingMessage } = useStore();

  if (!apiLoading) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex flex-col items-center justify-center gap-4 bg-overlay backdrop-blur-sm">
      <div className="h-14 w-14 animate-spin rounded-full border-[5px] border-borderSubtle border-t-gold dark:border-white/15" />
      <div className="text-center">
        <p className="text-lg font-medium text-textPrimary dark:text-white">
          {loadingMessage || 'Processing...'}
        </p>
        <p className="mt-1 text-sm text-textSecondary dark:text-white/60">
          Please wait
        </p>
      </div>
    </div>
  );
};

export default ApiLoadingOverlay;
